import { render } from "./UnderwriterList.vue?vue&type=template&id=3ebcd8bf&scoped=true&ts=true"
import script from "./UnderwriterList.vue?vue&type=script&lang=ts"
export * from "./UnderwriterList.vue?vue&type=script&lang=ts"

import "./UnderwriterList.vue?vue&type=style&index=0&id=3ebcd8bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebcd8bf"],['__file',"src/views/UnderwriterList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ebcd8bf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ebcd8bf', __exports__)) {
    api.reload('3ebcd8bf', __exports__)
  }
  
  module.hot.accept("./UnderwriterList.vue?vue&type=template&id=3ebcd8bf&scoped=true&ts=true", () => {
    api.rerender('3ebcd8bf', render)
  })

}


export default __exports__